import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLlmsData,
  fetchStudentPortalData,
  fetchOfficeData,
  fetchOnlinePaymentData,
  fetchPasswordManagmnetData,
  fetchHelpDeskData,
  fetchCouncillingData
} from "../../redux/slicer/itServicesSlice";

import {
  fetchHeaderData,
  fetchFlyerData,
  fetchJobData,
} from "../../redux/slicer/careersSlice";
import { fetchInternshipData } from "../../redux/slicer/researchAndStudentSlice";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { FaLink } from "react-icons/fa";
import { TiArrowSortedDown } from "react-icons/ti";
import { GoArrowRight } from "react-icons/go";
import { GiGraduateCap } from "react-icons/gi";
import { BiSolidRightArrow } from "react-icons/bi";
import { MdSimCardDownload } from "react-icons/md";
import Preloader from "../../assets/sab.png";
import ITservicesImg from "../../assets/Banners/ITServices.jpg";
import CouncillingVCard from "./CouncillingVCard";
function ITServices() {
  const [showCounsellingPopup, setShowCounsellingPopup] = useState(false);
  const dispatch = useDispatch();
  const {
    data: itServicesData,
    loading: itServicesLoading,
    error: itServicesError,
  } = useSelector((state) => state.services.llms);

  const {
    data: studentPortalData,
    loading: studentPortalLoading,
    error: studentPortaalError,
  } = useSelector((state) => state.services.studentPortal);

  const {
    data: officeData,
    loading: officeLoading,
    error: officeError,
  } = useSelector((state) => state.services.office);

  const {
    data: onlinePaymentData,
    loading: onlinePaymentLoading,
    error: onlinePaymentError,
  } = useSelector((state) => state.services.onlinePayment);

  const {
    data: passwordManagmentData,
    loading: passwordManagmentLoading,
    error: passwordManagmentError,
  } = useSelector((state) => state.services.passwordManagment);

  const {
    data: helpDeskData,
    loading: helpDeskLoading,
    error: helpDeskError,
  } = useSelector((state) => state.services.helpDesk);

  const {
    data: internshipData,
    loading: internshipLoading,
    error: internshipError,
  } = useSelector((state) => state.research.internship);

  const {
    data: headerData,
    loading: headerLoading,
    error: headerError,
  } = useSelector((state) => state.careers.header);

  const {
    data: flyerData,
    loading: flyerLoading,
    error: flyerError,
  } = useSelector((state) => state.careers.flyer);

  const {
    data: jobData,
    loading: jobLoading,
    error: jobError,
  } = useSelector((state) => state.careers.job);
  const {
    data: counsellingData,
    loading: councillingLoading,
    error: councillingError,
  } = useSelector((state) => state.services.councilling);

  const [selectedFlyer, setSelectedFlyer] = useState(null);
  useEffect(() => {
    dispatch(fetchLlmsData());
    dispatch(fetchStudentPortalData());
    dispatch(fetchOfficeData());
    dispatch(fetchOnlinePaymentData());
    dispatch(fetchPasswordManagmnetData());
    dispatch(fetchHelpDeskData());
    dispatch(fetchInternshipData());
    dispatch(fetchHeaderData());
    dispatch(fetchFlyerData());
    dispatch(fetchJobData());
    dispatch(fetchCouncillingData());
  }, [dispatch]);

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth", // Smooth scrolling
    });
  };
  const openCounsellingPopup = () => {
    setShowCounsellingPopup(true);
  };

  const closeCounsellingPopup = () => {
    setShowCounsellingPopup(false);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // if (
  //   itServicesLoading ||
  //   studentPortalLoading ||
  //   officeLoading ||
  //   onlinePaymentLoading ||
  //   passwordManagmentLoading ||
  //   helpDeskLoading
  // )
  //   return <p>Loading...</p>;
  // if (
  //   itServicesError ||
  //   studentPortaalError ||
  //   officeError ||
  //   onlinePaymentError ||
  //   passwordManagmentError ||
  //   helpDeskError
  // )
  //   return (
  //     <p>
  //       Error:{" "}
  //       {itServicesError ||
  //         studentPortaalError ||
  //         officeError ||
  //         onlinePaymentError ||
  //         passwordManagmentError ||
  //         helpDeskError}
  //     </p>
  //   );
  if (headerLoading || flyerLoading || jobLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (headerError || flyerError || jobError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {headerError || flyerError || jobError}
        </p>
      </div>
    );
  }

  if (!headerData || headerData.length === 0) {
    return <div>No Header Data Available</div>;
  }
  const { title, subtitle, image_url } = headerData[0];

  const closeFlyerModal = () => {
    setSelectedFlyer(null); // Reset selected flyer when closing modal
  };
  if (
    itServicesLoading ||
    studentPortalLoading ||
    officeLoading ||
    onlinePaymentLoading ||
    passwordManagmentLoading ||
    helpDeskLoading
  ) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (
    itServicesError ||
    studentPortaalError ||
    officeError ||
    onlinePaymentError ||
    passwordManagmentError ||
    helpDeskError
  ) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error:{" "}
          {itServicesError ||
            studentPortaalError ||
            officeError ||
            onlinePaymentError ||
            passwordManagmentError ||
            helpDeskError}
        </p>
      </div>
    );
  }
  return (
    <div>
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full h-[400px]">
          <img
            // src={
            //   "https://media.licdn.com/dms/image/v2/C5612AQFvQBLhCCe8Og/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1554761168009?e=2147483647&v=beta&t=ytczsmtmN46hjniIeeACs-5CF5s1oJIZKoy_VputTkE"
            // }
            src={ITservicesImg}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-5xl font-bold  font-titillium">
              Student Support
            </h2>
            <p className="text-lg mt-10 bg-img-description"></p>
          </div>
        </div>
      </div>

      <div className="flex item-end justify-end mr-5 mt-6">
        <div className="flex items-center justify-center gap-2 text-primary-color">
          <span>
            <a
              href="#"
              className="text-primary-color underline hover:text-secondary-color"
            >
              International Section
            </a>
          </span>
          <FaLink />
          <TiArrowSortedDown
            onClick={scrollToBottom}
            className="cursor-pointer text-xl hover:text-secondary-color"
          />
        </div>
      </div>

      <div className="py-6 mt-6">
        <h2
          className="text-2xl sm:text-4xl text-primary-color text-center font-titillium"
          id="service"
        >
          Service Menu
        </h2>
        <div className="px-4 sm:px-8 lg:px-28 py-6 mt-6">
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-3 gap-6"> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-3 gap-6">
            {itServicesData.map((service, index) => (
              <button
                key={service.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
                onClick={() => window.open(service.url, "_blank")}
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  Learning Management System
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  <h2 className="text-white text-md sm:text-lg"></h2>
                </div>
              </button>
            ))}

            {studentPortalData.map((portal, index) => (
              <button
                key={portal.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
                onClick={() => window.open(portal.url, "_blank")}
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  Student Portal
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  <h2 className="text-white text-md sm:text-lg"></h2>
                  {/* <button
              onClick={() => window.open(portal.url, "_blank")}
              className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-lg sm:text-xl"
            >
              <GoArrowRight />
            </button> */}
                </div>
              </button>
            ))}

            {officeData.map((office, index) => (
              <button
                key={office.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
                onClick={() => window.open(office.url, "_blank")}
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  Office 365
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  <h2 className="text-white text-md sm:text-lg"></h2>
                  {/* <button
              onClick={() => window.open(office.url, "_blank")}
              className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-lg sm:text-xl"
            >
              <GoArrowRight />
            </button> */}
                </div>
              </button>
            ))}

            {onlinePaymentData.map((payment, index) => (
              <button
                key={payment.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
                onClick={() => window.open(payment.url, "_blank")}
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  Online Payment
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  <h2 className="text-white text-md sm:text-lg"></h2>
                  {/* <button
              onClick={() => window.open(payment.url, "_blank")}
              className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-lg sm:text-xl"
            >
              <GoArrowRight />
            </button> */}
                </div>
              </button>
            ))}

            {passwordManagmentData.map((payment, index) => (
              <div
                key={payment.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
                onClick={() => window.open(payment.url, "_blank")}
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  Library
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  {/* <h2 className="text-white text-md sm:text-lg">Open</h2> */}
                  {/* <a
                    href={payment.file_url || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-lg sm:text-xl"
                  >
                    <MdSimCardDownload />
                  </a> */}
                </div>
              </div>
            ))}

            {helpDeskData.map((helpDesk, index) => (
              <div
                key={helpDesk.id || index}
                className="rounded-lg bg-Footer-color w-full max-w-[22rem] h-[22rem] mx-auto px-6 flex flex-col justify-between items-center text-center"
              >
                <h2 className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl flex-grow flex items-center justify-center font-inter">
                  IT Help Desk
                </h2>
                <div className="pt-4 pb-2 flex items-center justify-between w-full">
                  <h2 className="text-white text-md sm:text-lg">Open</h2>
                  <a
                    href={helpDesk.file_url || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-lg sm:text-xl"
                  >
                    <MdSimCardDownload />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full">
        {/* Hero Section */}
        {/* <div className="relative max-w-full mx-auto">
              <div className="overflow-hidden w-full  h-[300px] sm:h-[400px] relative">
                <img
                  src={image_url}
                  alt="carousel-slide"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white bg-black bg-opacity-40 px-10">
                  <h2 className="text-3xl sm:text-5xl font-bold font-titillium">
                    {title}
                  </h2>
                  <p className="text-sm sm:text-lg mt-4 sm:mt-4 font-inter">
                    {subtitle}
                  </p>
                </div>
              </div>
            </div> */}
        <div className="px-4 sm:px-6 lg:px-28 py-6" id="counselling">
          <div className="py-6">
            <p className="text-3xl sm:text-5xl text-primary-color font-titillium text-left">
            Student Counselling
            </p>
          </div>

          {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-3 gap-6">
            {counsellingData.map((data) => (
              <CouncillingVCard key={data.id} data={data} />
            ))}
          </div> */}

          <div className="mt-6 flex justify-start" >
            <button
              onClick={openCounsellingPopup}
              className="bg-primary-color text-white p-2 rounded"
            >
              Contact Us For Counselling
            </button>
          </div>
        </div>

        {/* Flyer Section */}
        <div className="px-4 sm:px-6 lg:px-28 py-6">
          <div className="py-6" id="flyer">
            <p className="text-3xl sm:text-4xl lg:text-5xl text-primary-color font-semibold font-titillium">
              Flyer Section
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {flyerData.map((flyer, index) => (
              <div
                key={index}
                className="py-4 cursor-pointer"
                onClick={() => setSelectedFlyer(flyer)} // Open modal with the flyer
              >
                <h2 className="font-bold text-left text-lg sm:text-xl font-inter">
                  {flyer.title}
                </h2>
                <img
                  src={flyer.image_url}
                  alt={flyer.title}
                  className="w-full h-[200px] sm:h-[300px] lg:h-[400px] object-cover rounded-t-lg"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Job Listings Section */}
        <div className="px-4 sm:px-6 lg:px-28 py-6">
          <div className="py-6" id="job">
            <p className="text-3xl sm:text-5xl text-primary-color  font-titillium">
             Careers
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {jobData.map((job) => (
              <div
                key={job.id}
                className="w-full h-[200px] shadow-2xl rounded p-4 flex flex-col items-center justify-center text-center"
              >
                <h2 className="text-lg sm:text-2xl font-bold font-inter">
                  {job.job_title}
                </h2>

                <h2 className="text-sm sm:text-xl mt-2 font-inter">
                  Platform Name -{" "}
                  <a
                    href={job.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 underline font-inter"
                  >
                    {job.platform_name}
                  </a>
                </h2>
                <div className="mt-4">
                  <button
                    className="bg-[#92288C] bg-opacity-10 w-[150px] sm:w-[200px] h-[40px] text-primary-color rounded font-inter"
                    onClick={() => window.open(job.url, "_blank")} // Open URL in a new tab
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Flyer Modal */}
        {/* Flyer Modal */}
        {selectedFlyer && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg max-w-[90%] sm:max-w-[600px] w-full relative">
              {/* Modal Header */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg sm:text-xl font-bold text-primary-color font-inter">
                  {selectedFlyer.title}
                </h2>
                {/* Close Button */}
                <button
                  type="button"
                  className="text-red-600 hover:text-red-800 text-2xl sm:text-4xl font-bold"
                  onClick={closeFlyerModal}
                >
                  &times;
                </button>
              </div>

              {/* Large Flyer View */}
              <div className="flex flex-col items-center">
                <img
                  src={selectedFlyer.image_url}
                  alt={selectedFlyer.title}
                  className="w-full h-[300px] sm:h-[400px] object-contain rounded-lg"
                />
              </div>
            </div>
          </div>
        )}
        <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
          <button
            onClick={scrollToTop}
            className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>

      {/* <div id="careers">
            <p className="text-4xl text-primary-color  font-titillium ">
              Career Guidence & InternShips
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {internshipData.map((internship) => (
                <div
                  key={internship.id}
                  className="w-full h-[200px] shadow-2xl rounded p-4 flex flex-col items-center justify-center text-center bg-[#92288C] bg-opacity-10"
                >
                  <h2 className="text-lg sm:text-2xl font-bold">
                    {internship.title}
                  </h2>

                  <div className="mt-4">
                    <button
                      className="bg-primary-color w-[150px] sm:w-[200px] h-[40px] text-white rounded"
                      onClick={() => window.open(internship.url, "_blank")} // Open URL in a new tab
                    >
                      Visit
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
      {/* <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div> */}

{showCounsellingPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg  w-full max-w-[95vw] max-h-[95vh] overflow-auto md:max-w-[80vw] lg:max-w-[70vw] p-4">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg sm:text-xl font-bold text-Footer-color font-inter">
                Counselling Contacts
              </h2>
              <button
                type="button"
                className="text-red-600 hover:text-red-800 text-2xl sm:text-4xl font-bold"
                onClick={closeCounsellingPopup}
              >
                ×
              </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
              {counsellingData.map((data) => (
                <CouncillingVCard key={data.id} data={data} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ITServices;
